import { dataOneToOne } from 'dls-icons-data'
import { createIcon } from '../common'

const IconOneToOne = /*#__PURE__*/createIcon(dataOneToOne)
export default IconOneToOne
